// index.js
import en from './en.json'
import th from './th.json'
import ja from './ja.json'
import zh from './zh.json'
import my from './my.json'

export const defaultLocale = 'en'

export const languages = {
    en: en,
    th: th,
    ja: ja,
    zh: zh,
    my: my
}